import { render, staticRenderFns } from "./DebtorContacts.vue?vue&type=template&id=fc25f7d0&"
import script from "./DebtorContacts.vue?vue&type=script&lang=js&"
export * from "./DebtorContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports